import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useCartStore = create(
  persist(
    (set, get) => ({
      items: [],
      deliveryInfo: null,
      coupon: null,

      addItem: (item) => {
        const items = get().items;
        const existing = items.find((i) => i.id === item.id);
        if (existing) {
          set({
            items: items.map((i) =>
              i.id === item.id
                ? { ...i, quantidade: Math.min(i.quantidade + 1, i.estoque) }
                : i
            ),
          });
        } else {
          set({ items: [...items, { ...item, quantidade: 1 }] });
        }
      },

      removeItem: (id) => {
        set({ items: get().items.filter((i) => i.id !== id) });
      },

      updateQuantity: (id, quantidade) => {
        if (quantidade <= 0) {
          get().removeItem(id);
        } else {
          set({
            items: get().items.map((i) =>
              i.id === id ? { ...i, quantidade: Math.min(quantidade, i.estoque) } : i
            ),
          });
        }
      },

      setDeliveryInfo: (info) => set({ deliveryInfo: info }),
      setCoupon: (coupon) => set({ coupon }),

      clearCart: () => set({ items: [], deliveryInfo: null, coupon: null }),

      getSubtotal: () => {
        return get().items.reduce((sum, item) => sum + item.preco * item.quantidade, 0);
      },

      getTotal: () => {
        const subtotal = get().getSubtotal();
        const coupon = get().coupon;
        const delivery = get().deliveryInfo;
        let discount = 0;
        if (coupon?.tipo === 'porcentagem') {
          discount = subtotal * (coupon.valor / 100);
        }
        const frete = delivery?.tipo === 'entregar' && !coupon?.frete_gratis
          ? (delivery?.valorFrete || 0)
          : 0;
        return subtotal - discount + frete;
      },

      getItemCount: () => {
        return get().items.reduce((sum, item) => sum + item.quantidade, 0);
      },
    }),
    { name: 'motoveloz-cart' }
  )
);
